export default __webpack_public_path__ + "static/media/Cheftastic Portfolio Image.038f44e7.png";